import React from 'react';
import { motion } from 'framer-motion';
export function ReasonSection() {
  return <section className="w-full bg-[#F7F2E7] py-20 px-6" data-id="element-219" data-mp="34q5fipr0cqlk">
      <div className="max-w-3xl mx-auto" data-id="element-220" data-mp="34plxl91cy27j">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-lg md:text-xl leading-relaxed text-[#0A1535]" data-id="element-221" data-mp="2qz8np14wodfk">
          <p className="font-bold text-2xl md:text-3xl text-[#C9A24B]" data-id="element-222" data-mp="280eahwl3bl1i">
            Hay una razón por la que eso ocurre.
          </p>

          <p data-id="element-223" data-mp="2d094wa42qsrb">Y no es falta de fe.</p>

          <p data-id="element-224" data-mp="2d1btgbdxcj42">
            La mayoría de los creyentes intentan cambiar sus circunstancias sin{' '}
            <span className="font-semibold" data-id="element-225" data-mp="66ovfgjlw72y">renovar primero su mente</span>.
          </p>

          <p data-id="element-226" data-mp="b72zkni36wvp">Intentan sentirse mejor sin transformar sus pensamientos.</p>

          <p data-id="element-227" data-mp="2n5vlda78izu9">
            Intentan confiar más en Dios sin desarrollar hábitos diarios que
            fortalezcan su fe.
          </p>
        </motion.div>
      </div>
    </section>;
}